/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * NO_PARTS — the test has none yet. POOL_TOO_SMALL — the part has too few questions in the language named. INSTRUCTION_MISSING — the test has instructions, but none in the language named. CATEGORY_NOT_IN_USE — the part draws from a category since switched off, as a copy may; pick another one. A test already live keeps running on it.
 * @export
 * @enum {string}
 */

export const TestGapCodeDto = {
    NoParts: 'NO_PARTS',
    PoolTooSmall: 'POOL_TOO_SMALL',
    InstructionMissing: 'INSTRUCTION_MISSING',
    CategoryNotInUse: 'CATEGORY_NOT_IN_USE'
} as const;

export type TestGapCodeDto = typeof TestGapCodeDto[keyof typeof TestGapCodeDto];



